import React from "react";
import {Page} from "../../components/page/page";
import styles from "./curious-mind.module.css";
import {ChooseButton} from "../../components/choose-button/choose-button";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";

const options = [
    {
        value: "Strongly agree",
        icon: "✅",
    },
    {
        value: "Somewhat agree",
        icon: "🤔",
    },
    {
        value: "Disagree",
        icon: "❌",
    },
];

const CuriousMindPage = () => {
    const dispatch = useDispatch();
    return (
        <Page
            title="”I have a curious mind and I always want to learn and grow”"
            hideContinueButton={true}
            currentStep="19"
        >
            <p className={styles.subtitle}>Do you agree with the statement?</p>
            <ul className={styles.list}>
                {options.map((option, i) => (
                    <li key={i}>
                        <Link
                            to="../optimist"
                            // onClick={() => dispatch((option.value))} TODO
                        >
                            <ChooseButton icon={option.icon}>{option.value}
                                <svg className={styles.arrow_icon} width="12" height="12"
                                     viewBox="0 0 12 12" fill="none">
                                    <g clip-path="url(#clip0_1973_11047)">
                                        <path d="M4 0.799219L9.6 5.99922L4 11.1992" stroke="black"
                                              stroke-linecap="square"></path>
                                    </g>
                                    <defs>
                                        <clipPath>
                                            <rect width="12" height="12" fill="white"
                                                  transform="translate(0 12) rotate(-90)"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </ChooseButton>
                        </Link>
                    </li>
                ))}
            </ul>
        </Page>
    );
};

export {CuriousMindPage};
